module.exports = __webpack_public_path__ + "img/pencil.166d3f56.svg";